import styled from '@emotion/styled';

import { LeftContainer } from '../../../../../styledComponents/Page/Page';

export const StyledLeftContainer = styled(LeftContainer)`
  gap: 5.3rem;
`;
